import { BondSortDirection } from './type';

export const isBondSortDirectionValid = (sortDirection: BondSortDirection | string): sortDirection is BondSortDirection => (sortDirection === 'ASC' || sortDirection === 'DESC');
